export const generateReferenceName = (name: string) => {

  // strip out non-url safe characters
  const sanitizedName = name.replace(/[^a-zA-Z0-9\s_]/g, '');

  // make string snake case
  const snakeCase = sanitizedName.replace(/\s+/g, '_').toLowerCase();

  return snakeCase;
}